'use strict';

import {measure, mutate} from './promise-fastdom';
import mergeOpts from './merge-opts';

export default function CanvasResize(canvas, options) {
    this.canvas = canvas;
    this.options = mergeOpts({
        dpr: 1 // true for devicePixelRatio
    }, options);

    window.addEventListener('resize', () => this.resize());
    return this.resize();
}

CanvasResize.prototype.resize = function () {
    const data = {};
    return Promise.resolve()
        .then(measure(() => {
            const dpr = this.options.dpr === true ? window.devicePixelRatio : this.options.dpr;
            const rect = this.canvas.getBoundingClientRect();
            data.realWidth = Math.round(rect.width * dpr);
            data.realHeight = Math.round(rect.height * dpr);
        }))
        .then(mutate(() => {
            this.canvas.width = data.realWidth;
            this.canvas.height = data.realHeight;
        }));
};
